import { Button, ButtonProps, CircularProgress } from "@mui/material";
import { useTranslations } from "next-intl";

interface LoadingButtonProps extends ButtonProps {
  loading?: boolean;
  loadingText?: string;
}

// TODO can we use the loading button from the other library
export const LoadingButton = ({
  loading,
  loadingText,
  sx,
  children,
  ...props
}: LoadingButtonProps) => {
  const t = useTranslations();
  return (
    <Button
      endIcon={loading && <CircularProgress size="1.2rem" color="inherit" />}
      sx={{
        ...sx,
        bgcolor: loading ? "#667085" : "", // TODO these should be theme variables
        "&:hover": { bgcolor: loading ? "#667085" : "" },
      }}
      disabled={loading}
      {...props}
    >
      {loading ? (loadingText ? t(loadingText) : children) : children}
    </Button>
  );
};
